import { ILabelJob } from "models/labelJob/labelJob.model";

export const countTotalLabelJobLabels = (item: ILabelJob): number => {
  return item.shipments.reduce((allTotal, shipment) => {
    const sum = shipment.packages.length;

    return allTotal + sum;
  }, 0);
};
